export default "__VITE_ASSET__ChBbAHb$__"